import { createContext, useContext } from 'react';

/**
 * Configuration du thème du site (format du configurateur classique, cf.
 * shared/theme/themeConfiguration) pour l'éditeur : les galeries des blocs
 * proposent ses styles, le canvas les applique (via le `metadata` de Puck,
 * cf. PuckPageEditor). `null` : thème jamais configuré, pas de styles.
 */
const ThemeConfigurationContext = createContext(null);

export const ThemeConfigurationProvider = ThemeConfigurationContext.Provider;

export const useThemeConfiguration = () => useContext(ThemeConfigurationContext);
